import { AppointmentPaymentStatusType } from '@/shared/types/appointment-payment-status-type';

export interface AppointmentProductPaymentDetails {
    paymentStatusId: string | null;
    partPayment: boolean;
    index: number;
    value: number | null;
    signingDate: string | Date | null;
    bankedDate: string | Date | null;
    clearedDate: string | Date | null;
    debtorDate: string | Date | null;
    noLongerProceedingDate: string | Date | null;
    writtenOffDate: string | Date | null;
    version?: number;
}

export function createAppointmentProductPaymentDetails(paymentStatus: AppointmentPaymentStatusType, index: number): AppointmentProductPaymentDetails {
    return {
        index,
        paymentStatusId: paymentStatus.id!,
        partPayment: paymentStatus.isPartPayment,
        signingDate: null,
        value: null,
        bankedDate: null,
        clearedDate: null,
        debtorDate: null,
        noLongerProceedingDate: null,
        writtenOffDate: null,
    };
}
